<template>
  <MaritalFields
    v-if="hasMaritalStatus || hasSpouseFields"
    v-model="family.marital"
    :has-spouse-fields
  />
  <FormBlock>
    <FormHeading :h="5">{{ $tt('parental_info') }}</FormHeading>
    <FamilyMemberFields
      v-model="family.father"
      :name-label="$tt('father_name')"
      :has-birth-country="hasParentsBirthCountry"
      :country-label="$tt('father_country')"
      class="mb-4"
    />
    <FamilyMemberFields
      v-model="family.mother"
      :name-label="$tt('mother_name')"
      :has-birth-country="hasParentsBirthCountry"
      :country-label="$tt('mother_country')"
    />
  </FormBlock>
</template>

<script setup lang="ts">
import type { Family } from '~/types';

const family = defineModel<Family>({ required: true });
defineProps<{
  hasParentsBirthCountry?: boolean;
  hasMaritalStatus?: boolean;
  hasSpouseFields?: boolean;
}>();
</script>